import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/59/thumb-landscape.jpg"

const Post59 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">FENDI／オーロック スウィング ホーボー／W32 x H11 x D5 (cm)</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
            夏の終わりが近づく8月末。日中はまだ強い日差しが続きますが、夕暮れの風はどこか柔らかく、街の空気に少しずつ秋の気配が混じり始めました。真夏の高揚感が落ち着きを帯びるこの時期は、装いにも小さな変化を加えたくなる頃です。人々のコーディネートも軽やかさはそのままに、晩夏のムードをまとい始めています。<br></br><br></br>
            Tシャツにデニム、リネンワンピースといった定番サマースタイルは、涼やかで着心地抜群です。それでも「そろそろ少し雰囲気を変えたい」と感じたら、アクセサリーや小物で季節の空気を先取りするのが正解です。<br></br><br></br>
            そんな時、全体をぐっと格上げしてくれるアイテムとして選びたいのが、FENDI（フェンディ）の「オーロック スウィング ホーボー」です。アクセサリーのような持ち手は、シンプルな装いに一点加えるだけで、ぐっと洗練された印象を演出できます。<br></br><br></br>
            それでは、サイズ感や収納力、そして実際のコーディネート例まで、気になるポイントをレビューしていきます。晩夏から秋にかけて、あなたのスタイルを一歩先へと導いてくれるバッグの魅力を、じっくりとお伝えします。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;FENDIの注目バッグ「オーロック スウィング ホーボー」をチェック！</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;必要なものをスマートに収められる絶妙なサイズ感</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec3" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;収納できるアイテムの例</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec4" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;バッグ開閉口</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;FENDI「オーロック スウィング ホーボー」晩夏スタイル</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec6" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;【ベージュバッグ】晩夏の軽やかさと上品さを両立</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec7" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;【ブラックバッグ】シックな魅力で晩夏から秋へシフト</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec8" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;まとめ：夏から秋へ。</ScrollLink><br></br>
          </div>
        </p>
      </div>         
      <figure name="sec1">
        <StaticImage src="../../images/posts/59/1.jpg" alt=""/>
      </figure>    
      <div className="text-max-width">
        <h1>FENDIの注目バッグ「オーロック スウィング ホーボー」をチェック！</h1>
      </div>
      <p className="text-max-width">90年代の空気感をベースに、今のスタイルにしっくりなじむ仕上がりです。ジュエリーアーティスティックディレクター、デルフィナ・デレトレズ・フェンディが手掛けたジュエリーコレクション「オーロック」をバッグへと昇華させたモデルです。</p>
      <p className="text-max-width">
        ブランドの象徴「FF」ロゴを落とし込んだオーバル型のメタルパーツと、べっ甲モチーフを組み合わせたオーロックチェーンが、ひと目でFENDIとわかる存在感を放っています。<br></br>
        デザインの着想源は、90年代のミニマルな“アンダー・ザ・アーム”スタイルです。その名の通り、コンパクトなボディを小脇に抱えるほか、クラッチバッグとしても楽しめる2WAY仕様になっています。
      </p>
      <p className="text-max-width">最大の魅力は、柔らかな曲線が描く独特のフォルムです。ホーボーバッグならではのリラックス感に、構築的なエレガンスが絶妙に融合しました。素材は、手に吸いつくような滑らかさを誇る上質なスムースレザーです。カラーバリエーションは、万能なブラックに加え、日差しに映える明るいベージュ、シーズンムードを高める鮮やかなカラーまで展開されています。</p>
      <p className="text-max-width space-bottom">特に8月後半は、ベージュで涼やかさを演出するのも良し、ブラックで秋の気配を先取りするのもおすすめです。今回は、その中からベージュとブラックのカラーをご紹介します。</p>
      <figure name="sec2">
        <StaticImage src="../../images/posts/59/2.jpg" alt=""/>
        <span className="text-center">収納できるアイテムの例</span>
      </figure>   
      <div className="text-max-width">
        <h1>必要なものをスマートに収められる絶妙なサイズ感</h1>
      </div>
      <p className="text-max-width">FENDI「オーロック スウィング ホーボー」は可愛いけれど収納力が心配…という声もありますが、実際には必要なものをスマートに収められる絶妙なサイズ感が魅力です。サイズはW32×H11×D5(cm)と横長でコンパクトなシルエットながら、見た目以上に効率よく荷物を整理できます。</p>
      <div name="sec3" className="text-max-width">
        <h2><span className="text-color-gray">◆ 収納できるアイテムの例</span></h2>
      </div>
      <p className="text-max-width">例えば、リップなどのコスメ、ハンカチ、ティッシュ、ハンドクリームといったお出かけに欠かせないアイテムをしっかり収納できます。必要最低限をきちんと収められるので、ホテルランチやショッピング、デートなど、手荷物をスマートにまとめたいシーンに最適です。</p>
      <p className="text-max-width">実際に二つ折り財布を入れてみましたが、高さが約5センチしかないため、収めることはできるものの少し窮屈に感じました。最近はキャッシュレス化が進んでいることもあり、お財布を持たずに出かける方も増えています。必要な場合は、薄型のビニールポーチにカードやお札を入れて持ち歩くと便利で、バッグにも無理なく収まります。こうした使い方をすると、コンパクトなバッグでもより快適に活用できると感じました。</p>
      <p className="text-max-width space-bottom">横長フォルムだからこそ、バッグを開いた時に中身が一目で見渡しやすく、出し入れがスムーズです。収納力とデザイン性を両立した、まさに“大人のためのコンパクトバッグ”といえます。</p>
      <figure>
        <StaticImage src="../../images/posts/59/3.jpg" alt=""/>
        <span className="text-center">開閉口：幅約20cm</span>
      </figure>   
      <div name="sec4" className="text-max-width">
        <h2><span className="text-color-gray">◆ バッグ開閉口</span></h2>
      </div>
      <p className="text-max-width space-bottom">FENDI「オーロック スウィング ホーボー」の開閉口は、幅約20cmでファスナー仕様となっており、安心感のあるつくりが魅力です。デザイン性だけでなく、防犯面にも配慮されているため、移動が多い日や人混みの中でも安心してお使いいただけます。また、ファスナーを閉めた状態でもバッグのシルエットは美しく保たれるため、機能性とエレガンスを兼ね備えた仕上がりになっています。</p>
      <figure name="sec5">
        <StaticImage src="../../images/posts/59/4.jpg" alt=""/>
      </figure>   
      <div className="text-max-width">
        <h1>FENDI「オーロック スウィング ホーボー」晩夏スタイル</h1>
      </div>
      <p className="text-max-width space-bottom">FENDI「オーロック スウィング ホーボー」は、その洗練されたデザインと使い勝手の良さで、晩夏のファッションをより一層楽しませてくれるバッグです。今回は、ベージュとブラックのカラーそれぞれの魅力と、シーンに合わせたコーディネート例をご紹介します。</p>
      <figure name="sec6">
        <StaticImage src="../../images/posts/59/5.jpg" alt=""/>
        <span className="text-center">FENDI／オーロック スウィング ホーボー／W32 x H11 x D5 (cm)</span>
      </figure>   
      <div className="text-max-width">
        <h2><span className="text-color-gray">◆ 【ベージュバッグ】晩夏の軽やかさと上品さを両立</span></h2>
      </div>
      <p className="text-max-width space-bottom">ベージュのバッグは、夏の明るい印象を保ちつつ、秋のトレンドカラーとも相性が良いため、季節の変わり目に重宝するアイテムです。晩夏は、夏の軽やかさと秋の落ち着きを融合させるスタイルが鍵となります。その柔らかな曲線を描くフォルムは、どんなスタイルにも自然に溶け込み、コーディネート全体を上品にまとめてくれます。</p>
      <div className="text-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/59/6.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-border-bottom">日常・おでかけスタイル</span></p>
          <p>晩夏らしい光沢感とリラックス感をミックスしたスタイルです。光沢のあるキャミソールワンピースとトップスを重ねて、華やかさと抜け感を演出しました。美術館にもぴったりな、上品で知的な印象です。白いサンダルを合わせて軽やかさをプラスし、バッグとトーンを合わせることで爽やかな統一感を出しました。オーロックチェーンがアクセントになり、シンプルな装いにモード感を添えます。ラグジュアリーだけど肩の力が抜けた、大人のためのコーディネートです。</p> 
        </div>
      </div>
      <div className="text-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/59/7.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-border-bottom">ホテルランチスタイル</span></p>
          <p>ダークブラウンのシアーなティアードワンピースが、軽やかで優雅な雰囲気を演出しています。ウエストリボンでメリハリをつけ、女性らしさを際立たせています。足元にはバイカラーのバレエシューズを合わせ、シックな中に可愛らしさをプラスしました。歩きやすさも兼ね備えているので、ホテル内の散策にもぴったりです。バッグとシューズのカラーが、重くなりがちなワンピースに軽やかさを添え、パールイヤリングが顔周りを上品に彩ります。ホテルランチにふさわしい、洗練された大人のスタイルです。</p> 
        </div>
      </div>
      <figure name="sec7">
        <StaticImage src="../../images/posts/59/8.jpg" alt=""/>
        <span className="text-center">FENDI／オーロック スウィング ホーボー／W32 x H11 x D5 (cm)</span>
      </figure>   
      <div className="text-max-width">
        <h2><span className="text-color-gray">◆ 【ブラックバッグ】シックな魅力で晩夏から秋へシフト</span></h2>
      </div>
      <p className="text-max-width space-bottom">ブラックのバッグは、晩夏のスタイルにシックな印象を添えてくれる定番のアイテムです。夏の明るさを程よく引き締め、秋に向けた落ち着きのある雰囲気を自然に演出してくれます。スタイリッシュで存在感のあるブラックは、シンプルな装いを格上げする効果があり、オンオフ問わず幅広いシーンで活躍します。その端正なフォルムは、トレンドに左右されることなく長く愛用でき、コーディネート全体に洗練された印象を与えてくれます。</p>
      <div className="text-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/59/9.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-border-bottom">日常・おでかけスタイル</span></p>
          <p>日常のお出かけにぴったりのリラックス感をプラスしたスタイルです。グレーのワントーンでまとめたコーディネートは、洗練された印象を与えます。ビスチェとトップスを重ね着することでトレンド感を演出しつつ、ワイドパンツとスニーカーを合わせることで、堅苦しくなりすぎず、程よいカジュアルさを加えています。足元のスニーカーが抜け感をプラスし、ゴールドのハート型ピアスと丸メガネが遊び心のあるアクセントになります。バッグの存在感ある太めのチェーンが、シンプルなコーディネートに奥行きを与え、全体をモードな印象に格上げしています。</p> 
        </div>
      </div>
      <div className="text-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/59/10.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-border-bottom">ホテルランチスタイル</span></p>
          <p>晩夏のホテルランチにふさわしい上品さとトレンド感を両立させたスタイルです。軽やかで透け感のある黒のブラウスとボルドーのワイドパンツの組み合わせが、シックで大人っぽい印象です。晩夏の季節感を演出し、ゆったりとしたシルエットでリラックス感もプラスしています。足元の華奢なストラップサンダルが女性らしさを引き立て、シルバーのアクセサリーが洗練された雰囲気を添えます。バッグのチェーンとオーロックモチーフが個性を加え、シンプルながらもディテールにこだわったスタイルです。</p> 
        </div>
      </div>
      <div name="sec8" className="text-max-width">
        <h1>まとめ：夏から秋へ。</h1>
      </div>
      <p className="text-max-width">FENDIの「オーロック スウィング ホーボー」は、夏の名残を感じさせながらも、秋の気配をさりげなく取り入れられる晩夏から初秋にぴったりのバッグです。</p>
      <p className="text-max-width">柔らかなフォルムと落ち着いたカラーは、軽やかさと上品さを兼ね備え、どんなコーディネートにも自然に馴染みます。いつもの夏服にプラスするだけで、季節の変わり目を意識した洗練スタイルに格上げできる一品です。</p>
      <p className="text-max-width">
        「ちょっと特別な存在感を取り入れたい」<br></br>
        「夏から秋へのおしゃれを楽しみたい」と感じる方なら、きっと手に入れたくなるはずです。<br></br>
        「オーロック スウィング ホーボー」と一緒に、夏の余韻と秋の始まりを楽しんでみてください。
      </p>
      <div className="border"></div> 
      <p className="text-max-width">📱憧れを日常に──ラクサスでフェンディを体験しよう！</p>     
      <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">フェンディのバッグはこちら</Link>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post59

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 59}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`